import { everest } from '~/services/serviceInstances';

export const deleteWorkflow = async ({ id }: { id: string }) => {
  return await everest.remove(`/workflows/${id}`);
};
